<template>
    <div class="common_details_table" :class="type_name!='look'?'common_details_table2':''" >
        <!-- {{table_check_list}} <br/> -->
        <el-checkbox class="checkbox_all" :disabled="is_all_checked" v-if="type_name!='look'&&is_put" v-model="all_checked" @change="all_check"></el-checkbox>
        <el-checkbox class="checkbox_all" v-if="type_name!='look' && !is_put" v-model="all_checked" @change="all_check"></el-checkbox>
        <el-checkbox-group v-model="table_check_list" @change="change_checkbox">
            <el-table
            :data="tableData">
                <el-table-column
                v-if="type_name!='look'"
                fixed="left"
                min-width="15">
                <template name="scope" slot-scope="scope">
                    <!-- <el-checkbox v-model="scope.row.is_check" @change="change_checkbox(scope.$index)"></el-checkbox> -->
                    <el-checkbox v-if="is_put" :disabled="scope.row.category_id==0?true:false" :label="scope.row.id"></el-checkbox>
                    <el-checkbox v-else :label="scope.row.id"></el-checkbox>
                </template> 
                </el-table-column>
                <el-table-column
                    v-for="(val,index) in tableTitle" :key="index"
                    :prop="val.prop"
                    :label="val.label"
                    >
                    <template slot-scope="scope">
                        <el-image :preview-src-list="[scope.row[val.prop]]" v-if="val.is_img" style="width:80px;height:80px;border:none;"  :src="scope.row[val.prop]"></el-image>
                        <div v-else>
                            <div v-if="val.is_turn">{{val.fun(scope.row[val.prop])}}</div>
                            <div v-else>{{scope.row[val.prop]===0?scope.row[val.prop]:scope.row[val.prop]===''?'--':scope.row[val.prop]}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                v-if="btnList"
                fixed="right"
                label="操作">
                <template name="scope" slot-scope="scope">
                    <el-button :type="item.btn_type" v-for="(item,index) in btnList" :key="index"
                    @click="item.fun(scope.row)" size="small"
                    >{{item.btn}}
                    </el-button>
                </template>
                </el-table-column>
            </el-table>
        </el-checkbox-group>
        <slot name="btn_box"></slot>
    </div>
</template>

<script>
export default {
    props:{
        tableData:Array, //表格数据 
        tableTitle:Array, //表格表头
        btnList:Array, //表格按钮
        get_status_fun:Function,
        type_name:String,
        is_put:Boolean
    },
    data(){
        return{
            all_checked:false,
            table_check_list:[],
            is_all_checked:false
        }
    },
    mounted(){

    },
    methods:{
        // 判断B数组中的所有元素是否都在A数组中
        check(A,B){
            var flag;
            for(var i=0; i<B.length; i++){
                flag = false;
                for(var j=0; j<A.length; j++)
                {
                    if(B[i] == A[j])
                    {
                        flag = true;
                        break;
                    }
                }
                //如果这个循环没有找到
                if(!flag)
                    break;
            }
            return flag;
        },
        del_check(A,B){
            for(var i=0; i<B.length; i++){
                for(var j=0; j<A.length; j++){
                    if(B[i] == A[j]){
                        A.splice(j,1)
                        break;
                    }
                }
            }
        },
        calculation(val){
            //console.log(val,'this.tableData111')

            if(this.is_put){
                this.is_all_checked = true
                val.forEach((val)=>{
                    if(val.category_id!=0){
                        this.is_all_checked = false
                    }
                })
            }

            let arr = []
            val.forEach(val=>{
                arr.push(val.id)
            })
            
            let is_check = this.check(this.table_check_list,arr)
            if(is_check){
                this.all_checked = true
            }else{
                this.all_checked = false
            }
        },  
        all_check(){
            //console.log(this.all_checked,'触发')
            if(this.all_checked){
                this.tableData.forEach(val=>{
                    if(val.category_id!=0){
                    if(!this.table_check_list.includes(val.id)){
                        this.table_check_list.push(val.id)
                    }
                    }
                })
            }else{
                let arr = []
                this.tableData.forEach(val=>{
                    arr.push(val.id)
                })
                this.del_check(this.table_check_list,arr)
            }
        },
        change_checkbox(){
            //console.log(this.table_check_list,'table_check_list')
            let arr = []
            this.tableData.forEach(val=>{
                arr.push(val.id)
            })
            let is_check = this.check(this.table_check_list,arr)
            if(is_check){
                this.all_checked = true
            }else{
                this.all_checked = false
            }
            //console.log(is_check,'is_check')
        },
        get_status(val) {
            return this.get_status_fun(val)
        },
        isImg(url) {
           if(!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)){
               return false
           }else{
               return true
           }
        },
        handleClick(e){
            //console.log(e)
        }
    }
}
</script>

<style lang="scss" scoped>
.common_details_table{
    position: relative;
    margin-top: 30px;
    // box-shadow: 0px -5px 10px 0px #eee, 
	// 		-6px 0px 6px 0px #eee, 
	// 		6px 0px 6px 0px #eee, 
	// 		0px 5px 19px 0px #eee;
    .checkbox_all{
        z-index: 999;
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .el-checkbox__label{
        display: none;
    }
    .ul_box{
        display: flex;
        .li_box{
            display: flex;
            flex: 1;
            padding: 10px;
        }
    }
}
.common_details_table2{
    .ul_box{
        padding-left:45px;
    }
}
</style>

<style lang="scss">
.common_details_table{
    .el-checkbox__label{
        display: none;
    }
}
</style>
